import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, FOLDERPATH } from "../Constants/config";

import {
  GET_PAYMENT_LOADING,
  GET_PAYMENT_SUCCESS,
  GET_PAYMENT_FAILED,
  PAYMENT_RECORD_LOADING,
  PAYMENT_RECORD_FAILED,
  PAYMENT_RECORD_SUCCESS,
  PAYMENT_SAVE_LOADING,
  PAYMENT_SAVE_FAILED,
  PAYMENT_SAVE_SUCCESS,
} from "../Constants/paymentConstants";

import { handleApiError } from "../Helper/actionHelper";

export const getPayment = (record) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: GET_PAYMENT_LOADING });
    const requestData = {
      token: userLocalData.id,
     ...record
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(
      FOLDERPATH + "/NewClientApi/getPaymentDetails",
      requestData,
      {
        headers: headers,
      }
    );

    dispatch({
      type: GET_PAYMENT_SUCCESS,
      payload: data,
    });
    handleApiError(data);
  } catch (error) {
    dispatch({
      type: GET_PAYMENT_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const getPaymentRecord = (record) => async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      dispatch({ type: PAYMENT_RECORD_LOADING });
      const requestData = {
        token: userLocalData.id,
        ...record
      };
  
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
  
      const { data } = await axios.post(
        FOLDERPATH + "/NewClientApi/paymentRecordDetails",
        requestData,
        {
          headers: headers,
        }
      );
  
      dispatch({
        type: PAYMENT_RECORD_SUCCESS,
        payload: data,
      });
      handleApiError(data);
    } catch (error) {
      dispatch({
        type: PAYMENT_RECORD_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
      handleApiError(error);
    }
  };

export const savePayment = (record) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    dispatch({ type: PAYMENT_SAVE_LOADING });

    const requestData = {
      token: userLocalData.id,
      ...record,
    };

    console.log(requestData);

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data: result } = await axios.post(
      FOLDERPATH + "/NewClientApi/savePaymentDetails",
      requestData,
      {
        headers: headers,
      }
    );

    if (result.status === "success") {
      const { data } = result;

      dispatch({
        type: PAYMENT_SAVE_SUCCESS,
        payload: result,
      });
    }
    return result;
    handleApiError(result);
  } catch (error) {
    dispatch({
      type: PAYMENT_SAVE_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const goToExternalURL=(data={})=> {
  const objectForSending = { sample1: "abc", sample2: "def" };

  const form = document.createElement("form");
  form.method = "POST";
  form.action = data.paymentUrl;

  // Sample 1
  const hiddenFieldSample1 = document.createElement("input");
  hiddenFieldSample1.type = "hidden";
  hiddenFieldSample1.name = "encRequest";
  hiddenFieldSample1.value = data?.encRequest;
  form.appendChild(hiddenFieldSample1);
  console.log(form);
  // Sample 2
  const hiddenFieldSample2 = document.createElement('input');
  hiddenFieldSample2.type = 'hidden';
  hiddenFieldSample2.name = 'access_code';
  hiddenFieldSample2.value = data?.access_code;
  form.appendChild(hiddenFieldSample2);

  document.body.appendChild(form);
  form.submit();
}


